import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OrderProvider } from "context/OrderContext";
import UserContext from "context/userContext";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ModalProvider } from "./context/ModalContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UserContext>
          <SnackbarProvider maxSnack={3}>
            <CartProvider>
              <ModalProvider>
                <OrderProvider>
                  <App />{" "}
                </OrderProvider>
              </ModalProvider>
            </CartProvider>
          </SnackbarProvider>
        </UserContext>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
